(function () {
  const HOLD_MS = 2000;
  const IN_MS = 150;
  const OUT_MS = 300;

  let toastEl = null;
  let hideTimer = null;

  function injectStyles() {
    if (document.getElementById('fp-toast-styles')) return;
    const style = document.createElement('style');
    style.id = 'fp-toast-styles';
    style.textContent = `
      #fp-toast {
        position: fixed;
        top: 80px;
        left: 50%;
        transform: translateX(-50%) translateY(-12px);
        background: var(--fp-green, #1e3a2f);
        color: var(--fp-white, #ffffff);
        font-family: var(--font-paragraph--family, 'Inter', sans-serif);
        font-weight: 700;
        font-size: 14px;
        padding: 12px 24px;
        border-radius: 100px;
        white-space: nowrap;
        z-index: 9999;
        opacity: 0;
        pointer-events: none;
        transition: opacity ${IN_MS}ms ease, transform ${IN_MS}ms ease;
        box-shadow: 0 4px 16px rgba(0,0,0,0.18);
      }
      #fp-toast.fp-toast--visible {
        opacity: 1;
        transform: translateX(-50%) translateY(0);
      }
      #fp-toast.fp-toast--hiding {
        opacity: 0;
        transform: translateX(-50%) translateY(-8px);
        transition: opacity ${OUT_MS}ms ease, transform ${OUT_MS}ms ease;
      }
    `;
    document.head.appendChild(style);
  }

  function getOrCreateToast() {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.id = 'fp-toast';
      toastEl.textContent = 'Product Added Successfully ✓';
      document.body.appendChild(toastEl);
    }
    return toastEl;
  }

  function showToast() {
    injectStyles();
    const el = getOrCreateToast();
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
    el.classList.remove('fp-toast--hiding');
    el.classList.add('fp-toast--visible');
    hideTimer = setTimeout(function () {
      el.classList.add('fp-toast--hiding');
      el.classList.remove('fp-toast--visible');
      hideTimer = null;
    }, HOLD_MS);
  }

  // SINGLE listener — cart:updated is fired by BOTH ATC paths:
  // 1. fruit-peti-product-card.liquid fires it directly after /cart/add.js
  // 2. fp-cart.js catches CartLinesUpdateEvent from product-form.js,
  //    re-fetches /cart.js, then fires cart:updated itself
  document.addEventListener('cart:updated', function (e) {
    console.log('[fp-toast] cart:updated fired ✓', e.detail);
    showToast();
  });

  // DEBUG: also log if CartLinesUpdateEvent somehow reaches document
  // (keeps this in for diagnostics — remove once confirmed working)
  document.addEventListener('@shopify/events/cart-lines-update', function (e) {
    console.log('[fp-toast] CartLinesUpdateEvent reached document (unexpected):', e);
  });

  console.log('[fp-toast] Initialized — listening for cart:updated');
})();
